import { useEffect, useRef, useState } from "react";
import { Bell, X, Sparkles } from "lucide-react";
import api from "../lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";

const SEEN_KEY = "pos_seen_version";

export function VersionsBell({ variant = "sidebar" }) {
  const [versions, setVersions] = useState([]);
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(false);
  const loaded = useRef(false);

  const load = () => {
    api.get("/app-versions").then((r) => {
      const v = r.data || [];
      setVersions(v);
      const latest = v[0]?.id;
      const seen = localStorage.getItem(SEEN_KEY);
      setUnread(!!latest && latest !== seen);
    }).catch(() => {});
  };

  useEffect(() => { if (!loaded.current) { loaded.current = true; load(); } }, []);

  const openModal = () => {
    setOpen(true);
    if (versions[0]?.id) { localStorage.setItem(SEEN_KEY, versions[0].id); setUnread(false); }
  };

  const btnCls = variant === "sidebar"
    ? "relative flex items-center gap-2 w-full px-4 py-2.5 rounded-xl text-sm font-medium text-white/80 hover:bg-white/10 transition-colors"
    : "relative w-10 h-10 rounded-xl flex items-center justify-center text-[#E85D04] hover:bg-[#E85D04]/10";

  return (
    <>
      <button data-testid="versions-bell" onClick={openModal} className={btnCls} title="Novedades">
        <Bell size={variant === "sidebar" ? 16 : 20} />
        {variant === "sidebar" && <span className="flex-1 text-left">Novedades</span>}
        {unread && <span data-testid="versions-unread" className="absolute top-1.5 right-2 w-2.5 h-2.5 rounded-full bg-[#DC2626] ring-2 ring-[#E85D04]" />}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="versions-modal">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl flex items-center gap-2"><Sparkles size={20} className="text-[#E85D04]" /> Novedades y versiones</DialogTitle>
            <DialogDescription>Mejoras y nuevas funciones del sistema.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3 max-h-[60vh] overflow-y-auto mt-1">
            {versions.length === 0 && <p className="text-sm text-[#111827]/50 text-center py-8">Aún no hay novedades publicadas.</p>}
            {versions.map((v, idx) => (
              <div key={v.id} data-testid={`version-item-${v.id}`} className="rounded-xl border border-[#111827]/10 bg-[#F8FAFC] p-3">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-extrabold px-2 py-0.5 rounded-full bg-[#E85D04] text-white">v{v.version}</span>
                  {idx === 0 && <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-[#16A34A]/15 text-[#16A34A]">NUEVO</span>}
                  <span className="ml-auto text-xs text-[#111827]/40">{v.created_at ? new Date(v.created_at).toLocaleDateString("es-MX") : ""}</span>
                </div>
                <p className="text-sm text-[#1F2937] whitespace-pre-wrap">{v.description}</p>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
